import { render, staticRenderFns } from "./ourSubInfo.vue?vue&type=template&id=6fcc8457&scoped=true"
import script from "./ourSubInfo.vue?vue&type=script&lang=js"
export * from "./ourSubInfo.vue?vue&type=script&lang=js"
import style0 from "./ourSubInfo.vue?vue&type=style&index=0&id=6fcc8457&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc8457",
  null
  
)

export default component.exports